import React, { useContext } from 'react';
import {
  DEFAULT_VIDEO_ROOM_MANAGER,
  VideoRoomManager,
  useVideoRoomManager,
} from 'shared/hooks/video-room';

export const VideoRoomContext = React.createContext<VideoRoomManager>(
  DEFAULT_VIDEO_ROOM_MANAGER,
);

export const VideoRoomProvider: React.FC = ({ children }) => {
  const videoRoomManager = useVideoRoomManager();

  return (
    <VideoRoomContext.Provider value={{ ...videoRoomManager }}>
      {children}
    </VideoRoomContext.Provider>
  );
};

export const useVideoRoomContext = () => {
  return useContext(VideoRoomContext);
};
